// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"

import Toggle from "../toggle"
import Config from "../../config"
import {updateShop} from "../../actions/shop"
import type {Shop, Dispatch, State as ReduxState} from "../../types"

type Props = {
  +t: any,
  +babyToken: string,
  +shop: Shop,
  +dispatch: Dispatch,
  +onClose: () => void,
}

type State = {
  isClosed: boolean,
}

class ShopAdminSettingsModal extends React.Component<Props, State> {
  handleSave: (SyntheticEvent<*>) => void
  handleCloseToggle: () => void

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {isClosed: props.shop.isClosed}

    this.handleSave = this.handleSave.bind(this)
    this.handleCloseToggle = this.handleCloseToggle.bind(this)
  }

  handleSave(e: SyntheticEvent<*>) {
    e.preventDefault()
    const {onClose, babyToken, dispatch} = this.props
    dispatch(updateShop(babyToken, this.state.isClosed))
    onClose()
  }

  handleCloseToggle() {
    this.setState({
      isClosed: !this.state.isClosed,
    })
  }

  renderClosedToggle() {
    const {t} = this.props
    const {isClosed} = this.state
    const labelL = t("shopAdmin.closed")
    const labelR = t("shopAdmin.open")
    const optL = {label: labelL, value: 1}
    const optR = {label: labelR, value: 0}
    return (
      <div className="mb-4">
        <Toggle
          optL={optL}
          optR={optR}
          selected={isClosed ? 1 : 0}
          onToggle={this.handleCloseToggle}
        />
      </div>
    )
  }

  renderBody() {
    const {t} = this.props
    return (
      <div>
        <div className="form-group">
          <label>{t("shopAdmin.settings.closedLabel")}</label>
          {this.renderClosedToggle()}
        </div>
        <button
          className="btn btn-primary"
          type="button"
          onClick={this.handleSave}
        >
          {t(`shopAdmin.modal.save`)}
        </button>
      </div>
    )
  }

  render() {
    const {t, onClose} = this.props
    return (
      <Modal
        className="modal-dialog modal-md"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={onClose}
        contentLabel={t("shopAdmin.settings.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t(`shopAdmin.settings.title`)}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">{this.renderBody()}</div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  shop: state.shop.shop,
  babyToken: Config.data.babyToken,
})

export default withTranslation()(
  connect(mapStateToProps)(ShopAdminSettingsModal)
)
